import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionModule } from '../Permission/permission.module';
import { AceCardModule } from '../UI-Lib/ACE/Card/card.module';
import { UserSetupComponent } from './Setup/userSetup.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { SignaturePanelComponent } from './Signature/signature-panel.component';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { UserSetupService } from './userSetup.service';

@NgModule({
    imports: [
        CommonModule,
        WeissmanSharedModule,
        ImageCropperComponent,
        PermissionModule,
        AceCardModule
    ],
    declarations: [
        SignaturePanelComponent,
        UserSetupComponent
    ],
    providers: [
        UserSetupService
    ],
    exports: [
        SignaturePanelComponent,
        UserSetupComponent
    ]
})
export class UserModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('signaturePanel', SignaturePanelComponent);
        hybridAdapterUtility.downgradeNg2Provider('sd.User.Setup.Service', UserSetupService);
    }
}
